import React from 'react';
import { connect } from 'react-redux';
import {
  retrieveInitiativeCategories,
  selectInitiativeCategoriesWithArchived,
} from '../../modules/initiativeCategories.js';
import InitiativeCategoryFormModal from '../../components/initiatives/InitiativeCategoryFormModal/index.jsx';

const mapStateToProps = (state) => ({
  initiativeCategories: selectInitiativeCategoriesWithArchived(state),
});

const mapDispatchToProps = { retrieveInitiativeCategories };

function InitiativeCategoryFormContainer(props) {
  const {
    categoryId,
    initiativeType,
    showFormModal,
    onHideFormModal,
    initiativeCategories,
  } = props;

  const category = categoryId
    ? initiativeCategories.find((category) => category.id === categoryId)
    : null;

  return (
    <InitiativeCategoryFormModal
      category={category}
      onHide={onHideFormModal}
      show={showFormModal}
      initiativeType={initiativeType}
    />
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InitiativeCategoryFormContainer);
